// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/es7.map.of.js
// module id = 558
// module chunks = 0